<script setup lang="ts" >
// !!! This code was automatically generated. You should not change it !!!
import { Annotations, AnnotationsConfigInterface, AnnotationItem } from '@unovis/ts'
import { onMounted, onUnmounted, computed, ref, watch, nextTick, inject } from 'vue'
import { arePropsEqual, useForwardProps } from '../../utils/props'
import { annotationsAccessorKey } from '../../utils/context'

const accessor = inject(annotationsAccessorKey)

// data and required props 
type Props = AnnotationsConfigInterface
const props = defineProps<Props & { data?: null }>()


// config
const config = useForwardProps(props)

// component declaration
const component = ref<Annotations>()


onMounted(() => {
  nextTick(() => {
    component.value = new Annotations(config.value)
    
    accessor.update(component.value)
  })
})

onUnmounted(() => {
  component.value?.destroy()
  accessor.destroy()
})

watch(config, (curr, prev) => {
  if (!arePropsEqual(curr, prev)) {
    component.value?.setConfig(config.value)
    component.value?.render()
  }
})


defineExpose({
  component
})
</script>

<script lang="ts">
export const VisAnnotationsSelectors = Annotations.selectors
</script>

<template>
  <div data-vis-annotations />
</template>


